import { render } from "./RiCustom.vue?vue&type=template&id=48b81cfe"
import script from "./RiCustom.vue?vue&type=script&lang=js"
export * from "./RiCustom.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiCustom.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "48b81cfe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('48b81cfe', __exports__)) {
    api.reload('48b81cfe', __exports__)
  }
  
  module.hot.accept("./RiCustom.vue?vue&type=template&id=48b81cfe", () => {
    api.rerender('48b81cfe', render)
  })

}


export default __exports__